// sortBlogs.jsx
import { compareDesc, parseISO } from "date-fns";

// Utility function for combining class names
export const cx = (...classNames) => classNames.filter(Boolean).join(" ");

// Function to sort blogs by their published date
export const sortBlogs = (blogs) => {
  return blogs
    .slice()
    .sort((a, b) =>
      compareDesc(parseISO(a.datePublished), parseISO(b.datePublished)) // Using datePublished instead of publishedAt
    );
};
